import { importTypes } from './importTypes';

export const ownerKeys = {
  addressType: 'addressType',
  flat: 'flat',
  surName: 'surName',
  firstName: 'firstName',
  partName: 'partName',
  phone: 'phone',
  email: 'email',
};

export const accountKeys = {
  addressType: 'addressTypeId',
  flat: 'flat',
  account: 'accountNumber',
  accountType: 'accountTypeId',
};

export const companyAccountKeys = {
  account: 'account',
  address: 'address',
  balance: 'balance',
};

export const individualMeterKeys = {
  addressType: 'addressTypeId',
  flat: 'flat',
  serviceType: 'serviceTypeId',
  serialNumber: 'serialNumber',
  model: 'model',
  mark: 'mark',
  sealNumber: 'sealNumber',
  location: 'locationId',
  readDateTime: 'readDateTime',
  reading1: 'currentValueTariff1',
  reading2: 'currentValueTariff2',
  reading3: 'currentValueTariff3',
  installationDateTime: 'installationDateTime',
  commissioningDateTime: 'commissioningDateTime',
  verificationDateTime: 'verificationDateTime',
  verificationInterval: 'verificationInterval',
  status: 'statusId',
};

export const settingStepFieldKeys = {
  [importTypes.owners]: ownerKeys,
  [importTypes.personalAccounts]: accountKeys,
  [importTypes.personalAccountsByCompanies]: companyAccountKeys,
  [importTypes.individualMeters]: individualMeterKeys,
};
